import { del, EndPoints, get, patch, post } from '../';
export function list() {
    return get(EndPoints.products, { all: 1 });
}
export function createProduct(request) {
    return post(EndPoints.productsCreate, request);
}
export function updateProduct(request) {
    return patch(EndPoints.productsUpdate, request);
}
export function deleteProduct(request) {
    return del("" + EndPoints.productsDelete, request);
}
